import loadable from "@loadable/component";

// Node16 module resolution requires .js extension, but loadable's types don't accept it

export const UiAddToSlackSection = loadable(
    // Node16 module resolution requires .js extension, cast via unknown to satisfy type checker
    () =>
        import("./UiAddToSlackSection.js") as unknown as Promise<
            typeof import("./UiAddToSlackSection")
        >
);
